import { useContext, useState } from "react";
import styled from "styled-components";
import Context from "./Context";

export default function MenuCel(){
    const {setNotas,setMenu,setId,videos,notas,setVideos,setMostrandoTodas,setTempo}=useContext(Context)
    
    const [op,setOp]=useState(false)
    function limitarTexto(texto, max) {
    return texto.length > max
      ? texto.slice(0, max) + '...'
      : texto
  }
  function excluir(ident){
        const nova=[]
        for(let video of videos){
        if(video.id!=ident)nova.push(video)
        }
        setVideos(nova)
        const novaNotas=[]
        for(let n of notas ){
            if(n.id!=ident)novaNotas.push(n)
        }
        setNotas(novaNotas)
    }
    return (
        <Tudo onClick={()=>setMenu(false)}>
          {notas.length==0?<h6>Você ainda não possui vídeos</h6>:
          [...videos].reverse().map(o=><Opcao
          
            onMouseEnter={() => setOp(o)}
            onMouseLeave={() => setOp(false)}
          >
            <Clicavel onClick={()=>{
                setMenu(false)
            setId(o.id);setTempo(false);setMostrandoTodas(false)
          }}/>
            {op&&op.id==o.id?<Detalhes
        onMouseEnter={() => setOp(op)}
            onMouseLeave={() => setOp(false)}
        >
            
            <footer>
                <button style={{background:'#ed7a65'}} onClick={()=>excluir(o.id)}>Excluir vídeo</button>
            </footer>
            
        </Detalhes>:<></>}

            {limitarTexto(o.titulo, 60)}
            
            <small>[{o.minutos}] {o.autor}</small>
            <h6></h6>
          </Opcao>)}
        </Tudo>
    )
}
/*
position:sticky;top:0;
width:calc(100% - 200px);
height:100%;
flex-direction:column;
padding:20px 20px 0 20px;

overflow:auto;
@media(max-width:850px){
width:100%
}
*/
const Tudo=styled.aside`

padding:20px 20px 0 20px;
background:#2A2A3F;
display:flex;
width:100%;
box-sizing:border-box;
height:calc(100% - 60px);
flex-direction:column;
align-items:flex-start;
overflow:auto;
@media(min-width:850px){
display:none
}
h6{color:white;font-size:18px;
width:100%;height:100%;display:flex;
align-items:center;justify-content:center;}
`
const Topo=styled.div`
align-items:center;
background:#2a2a3f;
position:sticky;top:0;
z-index:3;min-height:50px;
p{width:100%;color:white;font-size:18px;font-weight:500}
`
const Opcao=styled.div`
position:relative;cursor:pointer;
color:white;
background:royalblue;
flex-direction:column;
padding:10px;
margin-bottom:10px;
border-radius:10px;

font-size:17px;
small{font-size:13px;font-weight:300;margin:5px 0 0 0;color:#cccccc}
h6{color:#cccccc;width: max-content;font-size:14px;font-weight:300;margin:2px 0 2px 0;}
`
const Clicavel=styled.div`
position:absolute;
cursor:pointer;
width:100%;z-index:1;
height:100%;top:0;left:0;
border-radius:10px;
`
const Detalhes=styled.div`
width:130px;
max-width:calc(100vw - 200px);
position:absolute;
top:80px;z-index:1;
right:0;
background:white;color:black;
flex-direction:column;
padding:10px;
border-radius:10px;
 transition: opacity 0.6s ease;
 h1{margin:0;font-size:15px;font-weight:500;}
 h2{margin:0;font-size:15px;font-weight:400;}
 header{
 display:flex;justify-content:space-between;
 width:100%;
 }
 button{
width:120px;
height:40px;
border-radius:10px;border:0;
}
footer{
 margin-top:10px;
 display:flex;
 justify-content:flex-end;
 }
`
const Nota=styled.div`
background:yellow;
justify-content:space-between;
padding:10px;
flex-direction:column;
margin-top:10px;
border-radius:10px;
p{margin:0;}
`